import React from 'react';
import styled, { css } from 'styled-components';

import { BrandNavLogo } from 'components/perspectives/DefaultBrand';

const Container = styled.div(
  ({ theme }) => css`
    display: inline-flex;
    position: relative;
    span {
      font-size: 11px;
      position: absolute;
      right: 0;
      bottom: -${theme.spacings.xxs};
      line-height: 0;
    }
  `,
);

type Props = {
  className?: string;
};

const SecurityBrand = ({ className = '' }: Props) => (
  <Container className={`${className}`}>
    <BrandNavLogo />
    <span>Security</span>
  </Container>
);

export default SecurityBrand;
